(() => {
  'use strict';

  const timerState = window.__aparthyCartTimerState || { endAt: 0, durationMinutes: 0 };
  window.__aparthyCartTimerState = timerState;

  function initializeTimer(timer) {
    if (!timer || timer.dataset.aparthyTimerReady === 'true') return;
    timer.dataset.aparthyTimerReady = 'true';

    const durationMinutes = Math.max(1, Number.parseInt(timer.dataset.durationMinutes || '5', 10) || 5);
    if (!timerState.endAt || timerState.endAt <= Date.now() || timerState.durationMinutes !== durationMinutes) {
      timerState.endAt = Date.now() + durationMinutes * 60 * 1000;
      timerState.durationMinutes = durationMinutes;
    }

    const render = () => {
      if (!timer.isConnected) return;
      let seconds = Math.max(0, Math.ceil((timerState.endAt - Date.now()) / 1000));
      if (seconds <= 0) {
        timerState.endAt = Date.now() + durationMinutes * 60 * 1000;
        seconds = durationMinutes * 60;
      }
      const minutes = Math.floor(seconds / 60);
      const remainder = seconds % 60;
      const output = timer.querySelector('[data-aparthy-timer-value]');
      if (output) output.textContent = `${String(minutes).padStart(2, '0')}:${String(remainder).padStart(2, '0')}`;
      window.setTimeout(render, 1000);
    };

    render();
  }

  function initialize(scope = document) {
    scope.querySelectorAll?.('[data-aparthy-cart-timer]').forEach(initializeTimer);
  }

  function syncCustomHeaderTrigger(open) {
    document.querySelectorAll('.aparthy-header__cart[aria-controls="cart-drawer"]').forEach((trigger) => {
      trigger.setAttribute('aria-expanded', String(open));
    });
  }

  function updateCustomHeaderCount(itemCount) {
    document.querySelectorAll('.aparthy-header__cart').forEach((trigger) => {
      let bubble = trigger.querySelector('.aparthy-header__cart-count');
      if (itemCount <= 0) {
        bubble?.remove();
        return;
      }
      if (!bubble) {
        bubble = document.createElement('span');
        bubble.className = 'aparthy-header__cart-count';
        bubble.setAttribute('aria-hidden', 'true');
        trigger.appendChild(bubble);
      }
      bubble.textContent = String(itemCount);
    });
  }

  document.addEventListener('change', (event) => {
    const select = event.target.closest?.('[data-aparthy-upsell-variant]');
    if (!select) return;
    const card = select.closest('[data-aparthy-cart-upsell]');
    const option = select.selectedOptions?.[0];
    if (!card || !option) return;

    const variantInput = card.querySelector('[data-aparthy-upsell-variant-input]');
    const price = card.querySelector('[data-aparthy-upsell-price]');
    const compare = card.querySelector('[data-aparthy-upsell-compare]');
    const image = card.querySelector('.aparthy-cart-upsell__image');
    const addButton = card.querySelector('.aparthy-cart-upsell__add');
    if (variantInput) variantInput.value = option.value;
    if (price) price.textContent = option.dataset.price || '';
    if (compare) {
      compare.textContent = option.dataset.compare || '';
      compare.classList.toggle('is-hidden', !option.dataset.compare);
    }
    if (image && option.dataset.image) {
      image.removeAttribute('srcset');
      image.src = option.dataset.image;
      image.alt = option.dataset.imageAlt || card.querySelector('.aparthy-cart-upsell__title')?.textContent?.trim() || '';
    }
    if (addButton) addButton.disabled = option.disabled;
  });

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest?.('[data-aparthy-protection-toggle]');
    if (!toggle) return;
    event.preventDefault();
    if (toggle.disabled || toggle.dataset.pending === 'true') return;

    const protection = toggle.closest('[data-aparthy-shipping-protection]');
    if (!protection) return;
    toggle.dataset.pending = 'true';
    toggle.disabled = true;
    const selected = toggle.getAttribute('aria-checked') === 'true';

    if (selected) {
      const line = Number.parseInt(protection.dataset.line || '0', 10);
      const cartItems = protection.closest('cart-items-component');
      if (line > 0 && typeof cartItems?.updateQuantity === 'function') {
        cartItems.updateQuantity({ line, quantity: 0, action: 'clear' });
      } else {
        toggle.dataset.pending = 'false';
        toggle.disabled = false;
      }
      return;
    }

    const form = protection.querySelector('form');
    const submit = protection.querySelector('[data-aparthy-protection-submit]');
    if (form && submit) form.requestSubmit(submit);
    window.setTimeout(() => {
      if (!toggle.isConnected) return;
      toggle.dataset.pending = 'false';
      toggle.disabled = false;
    }, 1800);
  });

  document.addEventListener('theme-drawer:open', (event) => {
    if (event.target?.id === 'cart-drawer') syncCustomHeaderTrigger(true);
  });

  document.addEventListener('theme-drawer:close', (event) => {
    if (event.target?.id === 'cart-drawer') syncCustomHeaderTrigger(false);
  });

  document.addEventListener('shopify:cart:lines-update', (event) => {
    event.promise?.then(({ cart, detail }) => {
      const itemCount = Number(cart?.totalQuantity ?? detail?.itemCount ?? 0);
      updateCustomHeaderCount(itemCount);
    }).catch(() => {});
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  const observer = new MutationObserver((records) => {
    records.forEach((record) => record.addedNodes.forEach((node) => {
      if (node instanceof Element) initialize(node);
    }));
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
